export default "__VITE_ASSET__BmfEq3v5__"